import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import ProgressBar from 'components/ProgressBar';
import { SecurityActionType } from '../../type';
import { getStepsOptions } from './helper';

export interface SecurityStepsProps {
    type: SecurityActionType;
    className?: string;
}

export function getStep(pathname): number {
    // match时需要考虑 /2fa/install/2  这种特殊地址
    const matchResult = pathname.match(/\d(?=\D*$)/);

    return matchResult ? Number(matchResult[0]) : 1;
}

const SecuritySteps: React.FC<SecurityStepsProps> = ({ type, className }) => {
    const location = useLocation();
    const steps = useMemo(() => getStepsOptions(type), [type]);

    return (
        <ProgressBar
            steps={steps}
            selectedIndex={getStep(location.pathname)}
            className={classNames('modify-step', className)}
        />
    );
};

export default SecuritySteps;
